/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { Fragment } from 'react';

import { Colors } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import { Plan } from '@zapier/upsells/src/types';

const styles = {
  buttonLink: css`
    background: none !important;
    border: none;
    color: ${Colors.ocean};
    padding: 0 !important;
    cursor: pointer;
  `,
};

const views = {
  ['DEFAULT']: () => ({
    bodyText:
      "To turn on your Zap, you'll need access to more Zaps. Turn off some of your other Zaps or upgrade now to turn on this Zap.",
    type: 'DEFAULT',
    upgradeButtonText: 'Upgrade to Starter',
  }),

  ['DEFAULT_TRIAL_EXTENSION']: ({
    destinationPlan,
    onUpgradeClick,
  }: {
    destinationPlan: Plan;
    onUpgradeClick: () => void;
  }) => ({
    bodyText: (
      <Fragment>
        To turn on your Zap, you'll need access to more Zaps.{' '}
        <strong>Upgrade now</strong> or{' '}
        <strong>
          start a free 7-day trial of the{' '}
          <button css={styles.buttonLink} onClick={onUpgradeClick}>
            Professional plan
          </button>
        </strong>{' '}
        to use unlimited Zaps.
      </Fragment>
    ),
    type: 'DEFAULT_TRIAL_EXTENSION',
    upgradeButtonText: `Upgrade to ${destinationPlan.type}`,
  }),
};

type Props = {
  canExtendTrial: boolean;
  destinationPlan: Plan;
  onUpgradeClick: () => void;
};

export const getActiveView = ({
  canExtendTrial,
  destinationPlan,
  onUpgradeClick,
}: Props) =>
  canExtendTrial
    ? views.DEFAULT_TRIAL_EXTENSION({
        destinationPlan,
        onUpgradeClick,
      })
    : views.DEFAULT();
